/**
 * Created by Administrator on 2017/6/2.
 */
export function saveToLocal(key,val) {
  let seller = window.localStorage.__seller__;
  if(!seller){
    seller = {};
  } else {
    seller = JSON.parse(seller);
  }
  seller[key] = val;
  window.localStorage.__seller__ = JSON.stringify(seller);
}

export function getToLocal(key,def) {
  let seller = window.localStorage.__seller__;
  if(!seller){
    return def;
  }
  seller = JSON.parse(seller);
  let res = seller[key];
  return res || def;
}



// WEBPACK FOOTER //
// ./src/common/js/store.js